import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditCommissionTier extends TermCreateEdit {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return 'commission_tier';
    }
}
